import {DateTime} from 'luxon';

export function millisToFormat(ts: number, format?: string) {
  let date = DateTime.fromMillis(ts);
  return date.toFormat(format || 'dd.LL.yyyy H:mm');
}